import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import _ from 'lodash';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { FormatDatasetAdapter } from 'app/model/adapters/datasets/format-dataset.adapter';
import { DeltaDataset } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DeltaDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            schema: '*',
            parameters: '*',
            type: '*',
            linkedServiceName: '*',
            linkedService: '*',
            connectionSettings: __IS_FABRIC_DPE__ ? '*' : undefined,
            typeProperties: {
                location: '*'
            }
        }
    }
})
export class DeltaDatasetAdapter extends FormatDatasetAdapter<DeltaDataset, Model.DatasetV2Resource> {
    protected async _toResource(dataset: DeltaDataset): Promise<Model.DatasetV2Resource> {
        const modelDatasetResource = await super._toResource(dataset) as Model.DatasetV2Resource;
        const modelDataset = this.properties(modelDatasetResource) as Model.DeltaDataset;
        modelDataset.type = Metamodel.modelFor(DeltaDataset).name;
        modelDataset.typeProperties = modelDataset.typeProperties || {};
        if (dataset.location) {
            modelDataset.typeProperties.location = this.locationToResource(dataset);

            if (modelDataset.typeProperties.location.fileName) {
                //delta doesn't support fileName in location, remove it if exists
                delete modelDataset.typeProperties.location.fileName;
            }
        }

        modelDataset.schema = this.columnValueToResource(dataset, dataset.columns);

        if (dataset.raw) {
            const parsed = JSON.parse(dataset.raw);
            _.merge(modelDatasetResource, parsed);
        }
        return modelDatasetResource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetV2Resource, dataset?: DeltaDataset): Promise<DeltaDataset> {
        if (!dataset) {
            dataset = DeltaDataset.MODEL.create<DeltaDataset>(modelDatasetResource.name);
        }
        await super._toModel(modelDatasetResource, dataset);
        if (modelDatasetResource?.properties?.typeProperties?.location) {
            await this.locationToModel(modelDatasetResource, dataset);
        }

        dataset.columns = this.columnResourceToValue(dataset, modelDatasetResource.properties.schema);

        dataset.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelDatasetResource, DeltaDataset.MODEL));
        return dataset;
    }
}
